import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			height: "100vh",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			background: theme.palette.colors.paleGrey,
			position: "relative",
			zIndex: "10002",
			left: 0,
			top: 0,
			right: 0,
		},
		full: {
			position: "fixed",
			marginBottom: 0,
		},
	};
};

class Loading extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classNames(classes.root, {
					[classes.full]: this.props.fullScreen,
				})}
			/>
		);
	}
}
export default withStyles(styles)(Loading);
